import { event } from "vue-gtag";
import store from "@/store/index.js";
import { isProduction, isStaging } from "@/utils/env";

/**
 * Sends a gtag event only if the active user is not an employee
 * and the environment is production or staging.
 */
export function trackEvent(eventName, params) {
  if ((isProduction || isStaging) && !store.getters.activeUserIsEmployee) {
    event(eventName, params);
  }
}
